import React from "react";
import { View } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { keys } from "lodash";

import { styles } from "./styles";

export const StarQuestion = props => {
  const { question, selectedOptions, selectOption } = props;
  const { options } = question;

  const [selectedOptionId] = keys(selectedOptions).map(id => parseInt(id));
  const selectedIndex = options.findIndex(
    o => o.virtual_id === selectedOptionId,
  );

  return (
    <View style={styles.container}>
      {options.map((option, index) => {
        const colorFlag = index <= selectedIndex;
        return (
          <Icon
            key={index}
            onPress={() => selectOption(question, option)}
            name="star"
            color={colorFlag ? "#ffd000" : "#D3D3D3"}
            style={styles.icon}
          />
        );
      })}
    </View>
  );
};
